import angular from 'angular';

class modalNotificationCtrl {
  /* @ngInject */
  constructor(CONF) {
    this.CONF = CONF;
  }

  $onInit() {
    this.principal = angular.copy(this.resolve.principal);
    this.report = angular.copy(this.resolve.reportData);
    this.type = angular.copy(this.resolve.type);
  }

  close() {
    this.modalInstance.dismiss(this.data);
  }
}

angular.module('app.principal').component('modalNotification', {
  templateUrl: require('./modal-notification.html'),
  controller: modalNotificationCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
